import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const F1Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "F1IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M21.9193 12.0984C20.7327 11.3074 19.4298 10.6955 18.0464 10.2799C16.6696 9.86606 15.2457 9.65625 13.8144 9.65625H12.7661V7.89844C12.7661 7.5748 12.5038 7.3125 12.1802 7.3125C9.75372 7.3125 7.42493 8.25656 5.6958 9.89261V9.07031C5.6958 8.10107 4.90723 7.3125 3.93799 7.3125H2.76611C2.44247 7.3125 2.18018 7.5748 2.18018 7.89844V13.7578C2.18018 14.0815 2.44247 14.3438 2.76611 14.3438H3.35205C3.35205 15.6362 4.40338 16.6875 5.6958 16.6875C6.56143 16.6875 7.31827 16.2154 7.7243 15.5156H15.4642C15.8702 16.2154 16.627 16.6875 17.4927 16.6875C18.3583 16.6875 19.1151 16.2154 19.5212 15.5156H21.5942C21.9179 15.5156 22.1802 15.2533 22.1802 14.9297V12.5859C22.1802 12.2553 21.9157 12.0945 21.9193 12.0984ZM11.5942 8.50528V10.2422C11.5942 10.5658 11.8565 10.8281 12.1802 10.8281H13.8144C15.7005 10.8281 17.5929 11.2369 19.3127 12H5.6958V11.6277C7.11975 9.80884 9.2804 8.67068 11.5942 8.50528ZM3.35205 13.1719V8.48438H3.93799C4.26102 8.48438 4.52393 8.74728 4.52393 9.07031V12.3152C4.16916 12.5211 3.87314 12.8171 3.6673 13.1719H3.35205ZM5.6958 15.5156C5.04959 15.5156 4.52393 14.99 4.52393 14.3438C4.52393 13.6975 5.04959 13.1719 5.6958 13.1719C6.34201 13.1719 6.86768 13.6975 6.86768 14.3438C6.86768 14.99 6.34201 15.5156 5.6958 15.5156ZM8.03955 14.3438C8.03955 13.917 7.92435 13.5166 7.7243 13.1714H15.4642C15.2641 13.5166 15.1489 13.917 15.1489 14.3438H8.03955ZM17.4927 15.5156C16.8465 15.5156 16.3208 14.99 16.3208 14.3438C16.3208 13.6975 16.8465 13.1719 17.4927 13.1719C18.1389 13.1719 18.6646 13.6975 18.6646 14.3438C18.6646 14.99 18.1389 15.5156 17.4927 15.5156ZM19.8364 14.3438C19.8364 13.917 19.7212 13.5169 19.5212 13.1719H21.0083V14.3438H19.8364Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default F1Icon;
